import {
  ApplicationConfig,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideOptimus } from '@openng/optimus-ui/config';
import { routes } from './app.routes';

import { DatePipe, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

// Number and date pipes follow the UI language (same browser language as the translations):
// 1 234,5 in French instead of 1,234.5
registerLocaleData(localeFr);
const uiLocale = (navigator.language || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en-US';
import { provideHttpClient, withXhr } from '@angular/common/http';
import { provideTranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from '@openng/optimus-ui/api';
import MyPreset from './mypreset';

import { MultiHttpTranslateLoader } from './i18n/multi-http-translate-loader';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    { provide: LOCALE_ID, useValue: uiLocale },
    provideRouter(routes),
    provideTranslateService({
      loader: provideTranslateLoader(MultiHttpTranslateLoader),
      fallbackLang: 'en',
      lang: 'en',
    }),
    provideOptimus({
      ripple: true,

      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: false || 'none',
          cssLayer: {
            name: 'optimus',
            order: 'theme, base, optimus',
          },
        },
      },
    }),
    provideHttpClient(withXhr()),
    ConfirmationService,
    MessageService,
    DatePipe,
  ],
};
